/** Primary H2 style for main tab content headings. */
export const TAB_MAIN_TITLE_CLASS =
  "font-display text-4xl text-center tracking-tight";
